(function() { module.exports = this["vendor"]; }());


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 8
// module chunks = 0